import * as React from 'react';
/**
 * Private module reserved for @material-ui/x packages.
 */

export default function useId(idOverride) {
  var _React$useState = React.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  React.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/utils/unstable_useId.js
// module id = 465
// module chunks = 121